import api from '../configs/api.config';
import { WEFResponse } from '../Types';
import {
  ClientMissingRegistrations,
  RegistrationRequestPreviewResponse,
  RegistrationRequestSend,
  RegistrationRequestSendResponse
} from '../types/communication.types';

export const getClientsMissingRegistrations = async (monitoringListId?: string) => {
  const params = monitoringListId ? `?monitoringListId=${monitoringListId}` : '';
  const { data } = await api.get<WEFResponse<ClientMissingRegistrations[]>>(
    `/Communication/clients-missing-registrations${params}`
  );
  return data?.data ?? [];
};

export const previewRegistrationRequests = async (request: RegistrationRequestSend) => {
  const { data } = await api.post<WEFResponse<RegistrationRequestPreviewResponse>>(
    '/Communication/preview-registration-requests',
    request
  );
  return data?.data;
};

export const sendRegistrationRequests = async (request: RegistrationRequestSend) => {
  const { data } = await api.post<WEFResponse<RegistrationRequestSendResponse>>(
    '/Communication/send-registration-requests',
    request
  );
  return data?.data;
};
